import { createApp } from 'vue'
// TODO vue typings
// @ts-ignore
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import heywhaleUI from '@/plugins/heywhale-ui'
import '@/main.css'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(heywhaleUI)

app.mount('#app')
